import React from 'react';
import {MenuItem, TextField, TextFieldProps} from '@mui/material';
import {AGREEMENT_TYPES} from 'hooks/useSigningDemo';
import {useTranslate} from 'hooks/useTranslate';

interface AgreementTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
  // When set, an empty option with this label is offered (value '').
  emptyLabel?: string;
  sx?: TextFieldProps['sx'];
}

export const AgreementTypeSelect = ({
  value,
  onChange,
  emptyLabel,
  sx,
}: AgreementTypeSelectProps) => {
  const t = useTranslate();

  return (
    <TextField
      select
      size="small"
      label={t('demo.signing.documents.agreementType')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{
        inputLabel: {shrink: true},
        select: {displayEmpty: true},
      }}
      sx={{minWidth: 260, ...sx}}>
      {emptyLabel !== undefined && (
        <MenuItem value="">
          <em>{emptyLabel}</em>
        </MenuItem>
      )}
      {AGREEMENT_TYPES.map((type) => (
        <MenuItem key={type} value={type}>
          {type}
        </MenuItem>
      ))}
    </TextField>
  );
};
